/* TENDON redesign - plovouci ATC lista (PDP).
   - IntersectionObserver na buy boxu: lista se ukaze, kdyz ATC odscrolluje NAD viewport
   - tlacitko odesila hlavni formular (atribut form); v rezimu 'scroll' scrolluje zpet k buy boxu
   - stav (text tlacitka / disabled / cena) se zrcadli z buy boxu pres MutationObserver
   - 'on:variant:change' (stejny kontrakt jako tdn-r-gallery.js) aktualizuje titulek varianty a miniaturu */
if (!customElements.get('tdn-r-sticky-atc')) {
  class TdnRStickyAtc extends HTMLElement {
    constructor() {
      super();
      if (window.Shopify && Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this.initialised) return;
      this.initialised = true;

      this.form = document.getElementById(this.dataset.formId)
        || document.querySelector('.js-product form.js-product-form');
      this.sectionEl = document.getElementById(this.dataset.sectionId)
        || (this.form && this.form.closest('.js-product'));
      this.btn = this.querySelector('.js-satc-btn');
      this.btnLabel = this.querySelector('.js-satc-btn-label');
      this.priceEl = this.querySelector('.js-satc-price');
      this.variantEl = this.querySelector('.js-satc-variant');
      this.thumbImg = this.querySelector('.tdn-r-satc__thumb img');

      if (!this.form || !this.sectionEl || !this.btn) return;

      this.buyBox = this.form.closest('.product-info__block--buy-buttons') || this.form;

      this.io = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
      this.io.observe(this.buyBox);

      this.sectionEl.addEventListener('on:variant:change', this.onVariantChange.bind(this));

      const info = this.sectionEl.querySelector('.product-info');
      if (info) {
        this.mo = new MutationObserver(this.debouncedSync.bind(this));
        this.mo.observe(info, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });
      }

      this.btn.addEventListener('click', this.onButtonClick.bind(this));
      this.sync();
    }

    onIntersect(entries) {
      const entry = entries[entries.length - 1];
      const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.toggle(show);
    }

    /**
     * Zobrazi/skryje listu (transform + inert kvuli fokusu).
     * @param {boolean} show - true = zobrazit
     */
    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        this.removeAttribute('inert');
        this.sync();
      } else {
        this.setAttribute('inert', '');
      }
    }

    /**
     * Klik resi podle ZIVEHO stavu hlavniho tlacitka, ne podle ulozeneho modu -
     * dynamicke prekreslovani buy boxu muze mod na okamzik zastarat.
     */
    onButtonClick(evt) {
      const mainBtn = this.mainButton();
      const canSubmit = mainBtn && !mainBtn.disabled && mainBtn.getAttribute('aria-disabled') !== 'true';

      if (canSubmit) {
        if (this.btn.dataset.mode === 'scroll') {
          evt.preventDefault();
          this.sync();
          if (this.form.requestSubmit) {
            this.form.requestSubmit();
          } else {
            this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        }
        return;
      }

      evt.preventDefault();
      this.sync();
      this.buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    mainButton() {
      return this.form.querySelector('button[name="add"]');
    }

    debouncedSync() {
      clearTimeout(this.syncTimer);
      this.syncTimer = setTimeout(() => this.sync(), 100);
    }

    /** Prevezme stav (text tlacitka, disabled, cenu) z buy boxu. */
    sync() {
      const mainBtn = this.mainButton();
      if (mainBtn) {
        const label = (mainBtn.textContent || '').trim();
        if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') {
          const soldOut = label !== '' && label === this.dataset.soldOutText;
          this.btn.dataset.mode = 'scroll';
          this.btn.classList.add('tdn-r-satc__btn--outline');
          this.btnLabel.textContent = soldOut ? label : (this.dataset.selectLabel || label);
        } else {
          this.btn.dataset.mode = 'submit';
          this.btn.classList.remove('tdn-r-satc__btn--outline');
          if (label) this.btnLabel.textContent = label;
        }
      }

      const priceSrc = this.sectionEl.querySelector('.product-info .js-product-price');
      if (priceSrc) {
        const current = priceSrc.querySelector('.price__current') || priceSrc;
        const text = (current.textContent || '').trim().replace(/\s+/g, ' ');
        if (text) this.priceEl.textContent = text;
      }
    }

    /**
     * Reakce na zmenu varianty - titulek + miniatura z eventu,
     * cena/tlacitko se dotahnou pres sync po dynamickem prekresleni buy boxu.
     * @param {object} evt - event 'on:variant:change'
     */
    onVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (variant) {
        if (this.variantEl && variant.title) {
          this.variantEl.textContent = variant.title.split(' / ').join(' · ');
        }
        const media = variant.featured_media;
        if (this.thumbImg && media && media.preview_image && media.preview_image.src) {
          const src = media.preview_image.src;
          const sep = src.indexOf('?') === -1 ? '?' : '&';
          this.thumbImg.src = src + sep + 'width=128';
          this.thumbImg.removeAttribute('srcset');
          this.thumbImg.removeAttribute('sizes');
        }
      }
      this.debouncedSync();
      setTimeout(() => this.sync(), 400);
    }
  }

  customElements.define('tdn-r-sticky-atc', TdnRStickyAtc);
}
